<template>
  <div class="Calendar" :key="month">
    <div class="label pill solid">
      <span>{{title}}</span>
    </div>
      <div class="days">
        <div v-for="(day, i) in dayNames" :key="i">{{day}}</div>
      </div>
      <div class="days" v-for="(week, i) in weeks" :key="i">
        <div
          v-for="(day, i) in week"
          :key="i"
          :class="{
            today: day.slug === today,
            active: day.slug ? day.slug.replace(/\//g, '-') === active : false,
            clickable: day.events
          }"
        >
          <router-link v-if="day.events" :to="'?day=' + day.slug.replace(/\//g, '-')">{{day.day}}</router-link>
          <div v-else>{{day.day}}</div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Calendar',
  props: {
    active: {
      type: String
    },
    month: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dayNames: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      weeksEmpty: getWeeksEmpty()
    }
  },
  created () {
    this.loadPage()
  },
  updated () {
    this.loadPage()
  },
  methods: {
    loadPage () {
      const url = '/calendar' + this.month
      const calendar = this.$store.getters.getPage(url)
      if (!calendar) this.$store.dispatch('fetchPage', url)
    }
  },
  computed: {
    date () {
      return new Date()
    },
    page () {
      return this.$store.getters.getPage('/calendar' + this.month) || { }
    },
    calendar () {
      return this.page.calendar 
    },
    weeks () {
      return this.calendar ? this.calendar.weeks : this.weeksEmpty
    },
    title () {
      if (!this.calendar) return 'Loading…'

      let output = this.calendar.month 
      if (this.calendar.year !== this.date.getFullYear().toString()) {
        output += ' ' + this.calendar.year
      }

      return output
    },
    today () {
      let dd = this.date.getDate()
      if (dd < 10) dd = '0' + dd
      let mm = this.date.getMonth() + 1
      if (mm < 10) mm = '0' + mm
      return [this.date.getFullYear(), mm, dd].join('/')
    }
  }
}

function getWeeksEmpty () {
  return [[ ], [ ], [ ], [ ], [ ]].map(() => {
    return ['', '', '', '', '', '', ''].map(() => {
      return { day: '○' }
    })
  })
}
</script>

<style scoped>
.label {
  display: block;
  margin-bottom: 1rem;
}

.days {
  padding: 0 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  font-size: var(--fs1);
  line-height: var(--lh1);
}

.days > div {
  width: 14.28%;
  padding: 0.7rem 0 0.9rem 0;
  text-align: center;
  text-transform: uppercase;
}

.clickable {
  position: relative;
  cursor: pointer;
}

.clickable:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3.8rem;
  height: 3.8rem;
  border: var(--b1d);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: -1;
}

.clickable.active {
  color: white;
  z-index: 0;
}

.clickable.active:after {
  background-color: var(--accent);
  border-style: solid;
}

.today {
  color: var(--accent);
}
</style>

<style>
.no-touch .clickable:hover:after {
  border-color: var(--accent);
}
</style>